import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { C, ONE_TO_ONE_NOTE } from "./constants";
import { EMPTY_FUNCION, FuncionesEditor, funcionesValid } from "./FuncionesEditor";
import { DependencyResult } from "./DependencyResult";
import { PerceptionPanel } from "./PerceptionPanel";
import { ConversacionesGuiadas } from "./ConversacionesGuiadas";

const initial = (fs) => (fs?.length ? fs.map((f) => ({ ...f })) : Array.from({ length: 5 }, () => ({ ...EMPTY_FUNCION })));

const BlockA = ({ testId, data, onSaved }) => {
  const [funciones, setFunciones] = useState(initial(data.funciones));
  const [editing, setEditing] = useState(!data.result);
  const [saving, setSaving] = useState(false);

  async function save() {
    setSaving(true);
    try {
      const r = await api.put(`/consulting/tests/${testId}/tablero/capa2/funciones`, { funciones });
      onSaved(r.data);
      setEditing(false);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No pudimos guardar las funciones");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div data-testid="tablero-capa2-bloque-a">
      <h3 className="text-lg font-bold" style={{ color: C.text }}>Mapa de dependencias</h3>
      <p className="text-sm mt-1 mb-4" style={{ color: "#5B6B64" }}>Indica entre 5 y 12 funciones críticas del negocio y cómo de cubiertas están.</p>
      {editing ? (
        <>
          <FuncionesEditor funciones={funciones} setFunciones={setFunciones} />
          <button onClick={save} disabled={!funcionesValid(funciones) || saving} className="mt-4 inline-flex items-center gap-2 rounded-full px-6 py-2.5 text-sm font-semibold text-white disabled:opacity-40" style={{ background: C.green }} data-testid="tablero-capa2-save">
            {saving && <Loader2 className="w-4 h-4 animate-spin" />} Ver mi mapa de dependencias
          </button>
        </>
      ) : (
        <>
          <DependencyResult rows={data.result} />
          <button onClick={() => setEditing(true)} className="mt-4 text-sm font-semibold underline" style={{ color: C.green }} data-testid="tablero-capa2-edit">Cambiar mis funciones</button>
        </>
      )}
    </div>
  );
};

export const Capa2Section = ({ testId, data, onSaved }) => {
  const p = data.perception;
  return (
    <section className="rounded-2xl p-6 md:p-8 space-y-8" style={{ background: C.cream }} data-testid="tablero-capa2">
      <div>
        <div className="text-[10px] font-bold uppercase tracking-[0.22em]" style={{ color: C.gold }}>Capa 2 · Personas y equipo</div>
        <h2 className="font-display text-xl md:text-2xl font-bold mt-1" style={{ color: C.text }}>¿Dónde dependo demasiado de una función o de una persona, y qué percibe el equipo?</h2>
      </div>
      <BlockA testId={testId} data={data} onSaved={onSaved} />
      <div data-testid="tablero-capa2-bloque-b">
        <h3 className="text-lg font-bold mb-3" style={{ color: C.text }}>Percepción del equipo</h3>
        {p.mode === "contraste"
          ? <PerceptionPanel p={p} testId={testId} />
          : <ConversacionesGuiadas testId={testId} saved={data.conversaciones} onSaved={onSaved} />}
        <p className="mt-5 text-sm font-semibold" style={{ color: C.text }} data-testid="tablero-one-to-one-note">{ONE_TO_ONE_NOTE}</p>
      </div>
    </section>
  );
};
